import React, { useCallback, useState } from 'react';
import { Button } from './Button';
import { SyncLoader } from 'react-spinners';
import { authenticate as authenticatePatient } from 'store/Patients/api';
import { setPatient } from 'store/Patients/actions';
import { DobInput, validateDob, DOB_MASK_PLACEHOLDER } from './ui/DobInput';
import { useDispatch } from 'react-redux';
import { setAuthToken } from 'library/auth';

export const DobAuthForm = ({ onAuthenticate, encodedResourceId, resourceType }) => {
  const [dob, setDob] = useState('');
  const dispatch = useDispatch();
  // this should be done with formik instead
  const [form, setForm] = useState({ loading: false, error: null })
  const { loading, error } = form

  const { iso: isoDob, error: validationError } = validateDob(dob);
  const isComplete = dob.length === DOB_MASK_PLACEHOLDER.length;
  const visibleValidationError = isComplete ? validationError : null;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!isoDob) return;
    handleDobSubmit(isoDob);
  };


  const handleDobSubmit = async (dob: string) => {
    if (!encodedResourceId) return;
    authenticate(dob)
  };

  const authenticate = useCallback(async (dob) => {
    setForm({ loading: true, error: null });

    try {
      const data: any = await authenticatePatient({
        resource: {
          resource_type: resourceType,
          resource_id: encodedResourceId,
          birth_date: dob,
        }
      })

      let { auth_token, ...patient } = data
      dispatch(setPatient(patient))
      setAuthToken(auth_token)
      onAuthenticate()

      setForm(_form => ({ ..._form, loading: false }));
    } catch (error) {
      setForm({ loading: false, error: error.errors || 'Authentication failed. Please check your date of birth and try again.' });
    }
  }, [resourceType, encodedResourceId])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md bg-white rounded-xl shadow-lg p-8">
        <div className="text-center mb-6">
          <h1 className="text-2xl font-bold text-gray-800">Patient Portal</h1>
          <p className="text-gray-500 mt-2">
            Please enter your date of birth to verify your identity.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="dob" className="block text-sm font-medium text-gray-700 mb-1">
              Date of Birth
            </label>
            <DobInput
              id="dob"
              value={dob}
              onChange={setDob}
              required
              disabled={loading}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teamcare-cyan focus:border-transparent outline-none transition-all"
            />
          </div>

          {(visibleValidationError || (error && error.trim())) && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
              {visibleValidationError || error}
            </div>
          )}

          <Button
            title={
              loading ? (
                <SyncLoader size={8} color="#ffffff" />
              ) : (
                'Verify Identity'
              )
            }
            onClick={() => { }}
            variant="primary"
            disabled={loading || !isoDob}
            className="w-full"
          />
        </form>
      </div>
    </div>
  );
};
